// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__28bIc","cell":"ColumnAccessor_cell__2B0rR","firstCellAccent":"ColumnAccessor_firstCellAccent__3YCmE"};